export default "__VITE_ASSET__CeHndpTF__"